import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Card,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  LinearProgress,
  Alert,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import * as XLSX from "xlsx";
import { axiosInstances } from "./apiConfig";

const steps = ["Upload File", "Map Headers", "Confirm Import"];

const MasterDataImport = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [file, setFile] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [mapping, setMapping] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const entityFields = [
    { label: "Customer Name", value: "Customer.name" },
    { label: "Customer Email", value: "Customer.email" },
    { label: "Customer Phone", value: "Customer.phone" },
    // { label: "Address City", value: "Address.city" },
    // { label: "Product Code", value: "Product.code" },
    { label: "Admin Username", value: "Admin.username" },
    { label: "Admin Email", value: "Admin.email" },
    { label: "Admin Phone", value: "Admin.phoneNumber" },
    { label: "Admin Password", value: "Admin.password" },
    { label: "Admin FullName", value: "Admin.fullName" },
    { label: "Admin Status", value: "Admin.adm_status" },
    { label: "Admin Role", value: "Admin.role" },
    { label: "Admin LastLogin", value: "Admin.lastLogin" },
    { label: "DataUpload FileName", value: "DataUpload.fileName" },
    { label: "DataUpload FileType", value: "DataUpload.fileType" },
    { label: "DataUpload UploadStatus", value: "DataUpload.uploadStatus" },
    { label: "DataUpload RecordCount", value: "DataUpload.recordCount" },
    { label: "DataUpload ErrorMsg", value: "DataUpload.errorMessage" },
    { label: "DataUpload SourceModule", value: "DataUpload.sourceModule" },
    { label: "DataUpload UploadedBy", value: "DataUpload.uploadedBy" },
    { label: "Enquiry Mode", value: "Enquiry.enquiryMode" },
    { label: "Enquiry CustomerId", value: "Enquiry.customerId" },
    { label: "Enquiry Subject", value: "Enquiry.subject" },
    { label: "Enquiry Message", value: "Enquiry.message" },
    { label: "Enquiry Status", value: "Enquiry.enq_status" },
    { label: "Enquiry AssignedTo", value: "Enquiry.assignedTo" },
    { label: "Enquiry Data", value: "Enquiry.enquiryDate" },
    { label: "Enquiry ResponseDate", value: "Enquiry.responseDate" },
    { label: "Inventory Product", value: "Inventory.product" },
    { label: "Inventory QuantityAvailable", value: "Inventory.quantityAvailable" },
    { label: "Inventory QuantityReserved", value: "Inventory.quantityReserved" },
    { label: "Inventory RecordLevel", value: "Inventory.reorderLevel" },
    { label: "Inventory Location", value: "Inventory.location" },
    { label: "Inventory Status", value: "Inventory.inv_status" },
    { label: "Invoice No", value: "Invoice.invoiceNo" },
    { label: "Invoice OrderId", value: "Invoice.orderId" },
    { label: "Invoice customerId", value: "Invoice.customerId" },
    { label: "Invoice subTotal", value: "Invoice.subTotal" },
    { label: "Invoice discount", value: "Invoice.discount" },
    { label: "Invoice IGST", value: "Invoice.igst" },
    { label: "Invoice CGST", value: "Invoice.cgst" },
    { label: "Invoice SGST", value: "Invoice.sgst" },
    { label: "Invoice GrandTotal", value: "Invoice.grandTotal" },
    { label: "Invoice Status", value: "Invoice.inv_status" },
    { label: "Invoice Date", value: "Invoice.invoiceDate" },
    { label: "Invoice DueDate", value: "Invoice.dueDate" },
    { label: "Offer No", value: "Offer.ofrnum" },
    { label: "Offer VendorId", value: "Offer.vendorId" },
    { label: "Offer EnquiryId", value: "Offer.enquiryId" },
    { label: "Offer CusotmerId", value: "Offer.customerId" },
    { label: "Offer IGST", value: "Offer.igst" },
    { label: "Offer CGST", value: "Offer.cgst" },
    { label: "Offer SGST", value: "Offer.sgst" },
    { label: "Offer SubTotal", value: "Offer.subTotal" },
    { label: "Offer GrandTotal", value: "Offer.grandTotal" },
    { label: "Offer Status", value: "Offer.offer_status" },
    { label: "Offer Date", value: "Offer.offerDate" },
    { label: "Order No", value: "Order.orderNo" },
    { label: "Order CustomerId", value: "Order.customerId" },
    { label: "Order Status", value: "Order.ord_sts" },
    { label: "Order OfferId", value: "Order.offerId" },
    { label: "Order SubTotal", value: "Order.subTotal" },
    { label: "Order Discount", value: "Order.discount" },
    { label: "Order IGST", value: "Order.igst" },
    { label: "Order CGST", value: "Order.cgst" },
    { label: "Order SGST", value: "Order.sgst" },
    { label: "Order GrandTotal", value: "Order.grandTotal" },
    { label: "Order OrderDate", value: "Order.orderDate" },
    { label: "Payment Amount", value: "Payment.amount" },
    { label: "Payment Method", value: "Payment.paymentMethod" },
    { label: "Payment Status", value: "Payment.p_status" },
    { label: "Payment ReferNo", value: "Payment.referenceNumber" },
    { label: "Payment Currency", value: "Payment.currency" },
    { label: "Payment PayerName", value: "Payment.payerName" },
    { label: "Payment PayerEmail", value: "Payment.payerEmail" },
    { label: "Payment Date", value: "Payment.paymentDate" },
    { label: "Price Amount", value: "Price.amount" },
    { label: "Price ProductId", value: "Price.productId" },
    { label: "Price Quantity", value: "Price.quantity" },
    { label: "Price Total", value: "Price.total" },
    { label: "Price OfferId", value: "Price.offerId" },
    { label: "Product Name", value: "Product.productName" },
    { label: "Product Description", value: "Product.description" },
    { label: "Report Name", value: "Report.reportName" },
    { label: "Report Type", value: "Report.reportType" },
    { label: "Report By", value: "Report.generatedBy" },
    { label: "Report At", value: "Report.generatedAt" },
    { label: "Report Status", value: "Report.rpt_status" },
    { label: "Report Format", value: "Report.format" },
    { label: "Report Filapath", value: "Report.filePath" },
    { label: "Report Description", value: "Report.description" },
    { label: "Report FromDate", value: "Report.fromDate" },
    { label: "Report ToDate", value: "Report.toDate" },
    { label: "Report IsArchieved", value: "Report.isArchived" },
    { label: "User Name", value: "User.username" },
    { label: "User Email", value: "User.email" },
    { label: "User Password", value: "User.password" },
    { label: "User FullName", value: "User.fullName" },
    { label: "User Phone", value: "User.phoneNumber" },
    { label: "User Role", value: "User.role" },
    { label: "User Status", value: "User.usr_sts" },
    { label: "User LastLogin", value: "User.lastLogin" },
    { label: "Role", value: "Role.role" },
    { label: "Role Services", value: "Role.authorisedServices" },
    { label: "Role Pages", value: "Role.authorisedPages" },
  ];

  // Step 1: Upload & Read Headers
  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;
    setFile(uploadedFile);

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const headerRow = json[0];
      setHeaders(headerRow);
    };
    reader.readAsArrayBuffer(uploadedFile);
    setActiveStep(1);
  };

  // Step 2: Mapping selection
  const handleMappingChange = (header, value) => {
    setMapping((prev) => ({ ...prev, [header]: value }));
  };

  // Step 3: Submit data to backend
  // const handleSubmit = async () => {
  //   if (!file || Object.keys(mapping).length === 0) return;
  //   setLoading(true);
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("mapping", JSON.stringify(mapping));

  //   try {
  //     const resp = await axiosInstances.uploadfileAPI.post("/import", formData,
  //       { headers: { "Content-Type": "multipart/form-data" } }
  //     );
  //     setSuccessMsg(resp.data);
  //     setActiveStep(2);
  //   } catch (error) {
  //     setSuccessMsg("❌ Failed to import: " + error.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSubmit = async () => {
    if (!file) {
      setSuccessMsg("❌ Please upload a file before submitting.");
      return;
    }
    if (Object.keys(mapping).length === 0) {
      setSuccessMsg("❌ Please map at least one column before submitting.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("mapping", JSON.stringify(mapping));

    try {
      const resp = await axiosInstances.uploadfileAPI.post("/import", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const data = resp.data;
      // Ensure it handles both text and JSON
      if (typeof data === "object") {
        const { processed, successful, failed, message } = data;
        const summary = `✅ Import completed. 
Processed: ${processed}, Successful: ${successful}, Failed: ${failed}.
${message || ""}`;
        setSuccessMsg(summary);
      } else {
        setSuccessMsg(String(data));
      }

      setActiveStep(2);
    } catch (error) {
      setSuccessMsg(`❌ Failed to import: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };


  return (
    <Box sx={{ width: "80%", mx: "auto", mt: 5 }}>
      <Typography variant="h5" gutterBottom>
        📊 Master Data Import
      </Typography>

      <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* Step 1: Upload */}
      {activeStep === 0 && (
        <Card variant="outlined">
          <CardContent sx={{ textAlign: "center", py: 6 }}>
            <CloudUploadIcon color="primary" sx={{ fontSize: 60 }} />
            <Typography variant="h6" gutterBottom>
              Upload Master Excel File
            </Typography>
            <Button variant="contained" component="label" sx={{ mt: 2 }}>
              Select Excel File
              <input
                type="file"
                accept=".xlsx,.xls"
                hidden
                onChange={handleFileChange}
              />
            </Button>
          </CardContent>
        </Card>
      )}

      {/* Step 2: Mapping */}
      {activeStep === 1 && (
        <Card variant="outlined">
          <CardContent>
            <Typography variant="h6" gutterBottom>
              🧩 Map Excel Columns to Entity Fields
            </Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><b>Excel Header</b></TableCell>
                  <TableCell><b>Map To</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {headers.map((header) => (
                  <TableRow key={header}>
                    <TableCell>{header}</TableCell>
                    <TableCell>
                      <FormControl fullWidth size="small">
                        <InputLabel>Select Field</InputLabel>
                        <Select
                          value={mapping[header] || ""}
                          onChange={(e) =>
                            handleMappingChange(header, e.target.value)
                          }
                        >
                          {entityFields.map((f) => (
                            <MenuItem key={f.value} value={f.value}>
                              {f.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <Box sx={{ textAlign: "right", mt: 3 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                🚀 Upload & Process
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* Step 3: Confirmation */}
      {activeStep === 2 && (
        <Card variant="outlined">
          <CardContent sx={{ textAlign: "center", py: 6 }}>
            {loading && <LinearProgress />}
            {successMsg && (
              <Alert severity={successMsg.includes("❌") ? "error" : "success"}>
                {successMsg}
              </Alert>
            )}
            <Typography variant="body1" sx={{ mt: 2 }}>
              You can now close this window or upload another file.
            </Typography>
            <Button
              variant="outlined"
              sx={{ mt: 2 }}
              onClick={() => {
                setActiveStep(0);
                setHeaders([]);
                setMapping({});
                setSuccessMsg("");
              }}
            >
              Upload Another File
            </Button>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default MasterDataImport;
